import React, { useState } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import axios from "axios";
import API_URL from '../config/api'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addNote, fetchNotes } from '../hooks/notes'

function AddStudentsNotes() {
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const { userArray } = useSelector((state) => state.auth);
  const { list } = useSelector((state) => state.resturants);

  const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        {
          id: "category_id",
          title: "اختار الوجبة",
          type: "select",
          options:[{id:10,name:"الافطار"},{id:11,name:"الغداء"},{id:12,name:"العشاء"}],
        },
                { id: "note", title: "التعليق", type: "textarea" },

                { id: "image", title: "صورة الملاحظة (أن وجدت) ", type: "file" },

      ],
    },
  ];
  // const infoData = [
  //   {
  //     id: 0,
  //     title: "معلومات أساسية",
  //     inputs: [
  //       { id: "name", title: "الاسم", type: "text" },
  //       { id: "identity_number", title: "الرقم العسكري", type: "text" },
  //       { id: "rank", title: "الرتبة", type: "text" },
  //       { id: "work_place", title: "جهة العمل", type: "text" },
  //       {
  //         id: "restaurant",
  //         title: "اختار المطعم",
  //         type: "select",
  //         options: ["مطعم معهد الشرطه المستجدين", "مطعم معهد الرتب الاخرى"],
  //       },

  //       // 👇 ضيف الحقول المطلوبة من API
  //       { id: "email", title: "البريد الإلكتروني", type: "email" },
  //       { id: "password", title: "كلمة المرور", type: "password" },
  //       { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "password" },
  //       { id: "phone", title: "رقم الهاتف", type: "text" },
  //       { id: "username", title: "اسم المستخدم", type: "text" },
  //       { id: "national_number", title: "الرقم العسكري", type: "text" },
  //     ],
  //   },
  // ];


  const handleSubmit = async (formData) => {
    console.log(formData);
  const dataformData = new FormData();

  Object.keys(formData).forEach((key) => {
    dataformData.append(key, formData[key]);
  });
        dispatch(addNote(dataformData))
      .unwrap()
      .then(() => {
        dispatch(fetchNotes())
        alert('تم إضافة الملاحظة بنجاح');
        navigate("/dashboard/student-notes")

      })
      .catch((err) => {
        alert(err);
      });

  };
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"إضافة ملاحظة جديدة"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
          formStructure={infoData}
          image={false}
          onSubmit={handleSubmit}

        />
      </Container>
    </div>
  )
}

export default AddStudentsNotes
